import { render, staticRenderFns } from "./ApplicantDetailsBlock.vue?vue&type=template&id=63b0ef5e&scoped=true"
import script from "./ApplicantDetailsBlock.vue?vue&type=script&lang=js"
export * from "./ApplicantDetailsBlock.vue?vue&type=script&lang=js"
import style0 from "./ApplicantDetailsBlock.vue?vue&type=style&index=0&id=63b0ef5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b0ef5e",
  null
  
)

export default component.exports